// extracted by mini-css-extract-plugin
export var body = "fp-Ri";
export var grid = "fp-Si";
export var gridWithRowGap = "fp-Ti";
export var maxWidthContainer = "fp-Xi";
export var mt0 = "fp-Ki";
export var mt1 = "fp-Li";
export var mt2 = "fp-Mi";
export var mt3 = "fp-Ni";
export var mt4 = "fp-Oi";
export var mt5 = "fp-Pi";
export var mt6 = "fp-Qi";
export var removeVisuallyHidden = "fp-Vi";
export var visuallyHidden = "fp-Ui";
export var widgetBase = "fp-Wi";